var _defs, _rect, _line, _line2, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack163({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 2.44,
    y: 1,
    width: 11.13,
    height: 11.13
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.44,
    y1: 1,
    x2: 13.56,
    y2: 12.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.47,
    y1: 1.09,
    x2: 2.53,
    y2: 12.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.49,
    y: 11.42,
    width: 1.02,
    height: 6.14,
    rx: 0.5,
    transform: "translate(-6.49 22.49) rotate(-90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.49,
    y: 12.16,
    width: 1.02,
    height: 1.82
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack163);
export default __webpack_public_path__ + "static/media/Symbolpack_1_63.f335e3ac3efa952d083031bf4a2cc172.svg";
export { ForwardRef as ReactComponent };